import { useState, useEffect } from 'react';
import { EnterCode, InputError, LightTooltip, ShowInfo } from '../../utils';
import { useTimer } from 'react-timer-hook';
import Modal from '@mui/material/Modal';
import Rules from './Rules';
import { sendOtp, verifyOtp } from '../../../api/MoadianService';
import { useDispatch, useSelector } from 'react-redux';
import { apiClient } from './../../../api/ApiClient'
import { setToken } from '../../redux/actions/TokneAction';
import { notify } from '../../utils';
import { useNavigate } from "react-router-dom";
import { checkInfoStatus } from '../../../api/MoadianService';
import { ChangeStep } from '../../redux/actions/StepperAction';

export default function OtpForm({ setGoToPage }) {

    const phoneNumber = useSelector(state => state.FirstInfo.phoneNumber);
    const [code, setCode] = useState('');
    const [stopTimer, setStopTimer] = useState(false);
    const [codeError, setCodeError] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [intervalId, setIntervalId] = useState(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const firstInfo = useSelector(state => state.FirstInfo);
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isResetCode, setIsRestCode] = useState(false)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const timer = useTimer({
        autoStart: !stopTimer,
        expiryTimestamp: new Date(new Date().getTime() + 120000),
        onExpire: () => setStopTimer(true)
    });

    useEffect(() => {

        const fetchData = async () => {

            if (!formSubmitted) {
                sendOtp(firstInfo).then().catch(error => alert(error?.response?.data?.message))
            }
        };

    }, [formSubmitted]);

    const onSubmit = () => {

        setIsSubmitted(true)
        if (code.length != 6) {
            setIsSubmitted(false)
            setCodeError('کد وارد شده باید 6 رقم باشد')
        } else {

            const otpInfo = {
                "phoneNumber": firstInfo.phoneNumber,
                "nationalId": firstInfo.nationalId,
                "otp": code
            }

            verifyOtp(otpInfo).then(response => {

                if (response.data.errorCode == 'OK') {
                    const jwtToken = 'Bearer ' + response.data.token

                    apiClient.interceptors.request.use(
                        (config) => {
                            config.headers.Authorization = jwtToken
                            return config
                        }
                    )

                    const tokenData = {
                        token: response.data.token,
                        refreshToken: response.data.refreshToken,
                        tokenExpiresIn: response.data.tokenExpiresIn,
                        refreshTokenExpiresIn: response.data.refreshTokenExpiresIn,
                        transactionId: response.data.transactionId,
                        status: response.data.status,
                        traceId: response.data.traceId
                    }
                    dispatch(setToken(tokenData))
                    clearInterval(intervalId);
                    // Reset the timer to 60 seconds
                    setFormSubmitted(true);
                    setCodeError('')
                    setIsSubmitted(false)

                    if (response?.data?.statusCode === 2003) {
                        navigate('/fill-done')
                    } else
                        if (response?.data?.multiCert) {
                            navigate('/company/list')
                        } else if (response?.data?.statusCode === 2002) {
                            navigate('/fill-user-info')
                        }

                        else {



                            checkInfoStatus().then(statusResponse => {
                                const { isAutomate, checkInfoState } = statusResponse.data;

                                if (isAutomate) {
                                    // Keep current behavior
                                    if (response.data.status === "INITIAL") {
                                        setOpenModal(true)
                                    } else {
                                        navigate('/main')
                                    }
                                } else {
                                    // Handle different checkInfoState values
                                    if (checkInfoState === 'INITIAL' || checkInfoState === 'CHECK_EKYC') {
                                        // dispatch(ChangeStep(6));
                                        navigate('/fill-done')
                                    } else if (checkInfoState === 'ACCEPTED') {
                                        dispatch(ChangeStep(3));
                                        navigate('/main')
                                    } else {
                                        // Unknown state, use default behavior
                                        if (response.data.status === "INITIAL") {
                                            setOpenModal(true)
                                        } else {
                                            navigate('/main')
                                        }
                                    }
                                }
                            }).catch(error => {
                                // If checkInfoStatus fails, use default behavior
                                console.error('Error checking info status:', error);
                                notify(error.response.data.message)
                                if (response.data.status === "INITIAL") {
                                    setOpenModal(true)
                                } else {
                                    navigate('/login')
                                }
                            });
















                        }

                    // else {
                    //     if(!response?.data?.acceptedTerms){
                    //         setOpenModal(true)
                    //     }else{
                    //         navigate('/main')
                    //     }
                    // }

                }
            }).catch(error => {
                if (error?.response?.data?.errorCode === "USER_PROFILE_NOT_FOUND") {
                    setIsSubmitted(false);
                    notify(error.response.data.message);
                    setGoToPage('login');

                } else {
                    setIsSubmitted(false)
                    notify(error.response.data.message)
                }
            }
            )

        }
    }

    const formatTime = (time) => {
        return `${timer.minutes}:${timer.seconds}`;
    };

    const resendOtp = () => {
        sendOtp(firstInfo).then().catch(error => notify(error.response.data.message));
        setCode('')
        setCodeError('')
        setIsRestCode(!isResetCode)
        setStopTimer(false);
        timer.restart(new Date(new Date().getTime() + 120000), true);
    }

    return (

        <div>
            <ShowInfo
                title={'کد تایید'}
                message={'کد تایید ارسال شده به شماره موبایل خود را وارد کنید.'}
            />
            <div className="container my-5">
                <div className='row justify-content-center my-4 '>

                    <div className='col-12 col-md-5 p-0 text-center'>
                        <span
                            className='text-format'
                            style={{ 'color': 'black', 'fontSize': '0.9rem' }}
                        >کد تایید ارسال شده به {phoneNumber}</span>

                        <LightTooltip tooltip_title={'کد ارسال شده'} />

                        <span
                            onClick={() => { setGoToPage('login') }}
                            className='text-format'
                            style={{ 'color': '#0BA9B5', 'cursor': 'pointer', 'fontSize': "0.7rem" }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ "margin": "1%" }}>
                                <path fillRule="evenodd" clipRule="evenodd" d="M13.4616 12.4524C13.7588 12.4524 14 12.6923 14 12.9879C14 13.2835 13.7588 13.5234 13.4616 13.5234H8.2544C7.95717 13.5234 7.71595 13.2835 7.71595 12.9879C7.71595 12.6923 7.95717 12.4524 8.2544 12.4524H13.4616ZM10.1345 0.466721C10.1704 0.494568 11.3715 1.42281 11.3715 1.42281C11.808 1.68129 12.149 2.14326 12.2783 2.69021C12.4068 3.23145 12.3134 3.78982 12.0141 4.26179C12.0121 4.26494 12.0101 4.26805 12.0031 4.2773L11.9977 4.28445C11.9491 4.34815 11.7379 4.6138 10.6717 5.94232C10.6618 5.95973 10.6506 5.97604 10.6384 5.99189C10.6204 6.01524 10.6008 6.03671 10.5799 6.05626C10.5072 6.14733 10.4304 6.24301 10.3496 6.34361L10.186 6.54744C9.84836 6.96799 9.44787 7.46667 8.97275 8.05816L8.72891 8.3617C7.81163 9.50355 6.63687 10.9655 5.13197 12.838C4.80244 13.2464 4.3085 13.4842 3.77795 13.4906L1.1654 13.5235H1.15822C0.909098 13.5235 0.692283 13.3535 0.63413 13.1115L0.0461445 10.6331C-0.0751858 10.1197 0.0454266 9.58988 0.376393 9.1786L7.1393 0.765899C7.14218 0.763043 7.14433 0.759473 7.1472 0.756617C7.88883 -0.12521 9.22992 -0.255164 10.1345 0.466721ZM6.38528 3.41806L1.21709 9.84765C1.09432 10.0005 1.04909 10.1975 1.09432 10.3867L1.58324 12.4467L3.76503 12.4196C3.97251 12.4174 4.1642 12.3253 4.29127 12.1682C4.94565 11.354 5.7681 10.3305 6.61368 9.27812L6.91284 8.90579L7.21251 8.53281C8.00552 7.54579 8.78896 6.57055 9.44448 5.75427L6.38528 3.41806ZM7.97641 1.43994L7.05798 2.58122L10.1169 4.91676C10.7057 4.18329 11.093 3.7002 11.1288 3.65415C11.2466 3.46422 11.2925 3.19574 11.2308 2.93726C11.1676 2.67236 11.0018 2.44744 10.7627 2.30392C10.7117 2.26893 9.50202 1.33498 9.46468 1.30571C9.00952 0.942979 8.34543 1.00581 7.97641 1.43994Z" fill="#0BA9B5" />
                            </svg>
                            ویرایش شماره
                        </span>
                    </div>
                </div>

                <div className='row justify-content-center mt-4 mb-1 '>
                    <div className='col-12 col-md-4 pt-3 pb-0 px-4 px-md-0'>
                        <EnterCode callback={(data) => {
                            setCode(data);
                        }} codeError={codeError} isResetCode={isResetCode} />
                        <InputError show={!!codeError} message={codeError} />
                    </div>
                </div>

                <div className='row justify-content-center my-4 '>
                    <div className='col-12 col-md-5'>
                        <button
                            onClick={onSubmit}
                            className='btn w-100 text-form-button'
                            style={{ "background": "#044448" }}
                            disabled={isSubmitted}
                        >تایید</button>
                    </div>
                </div>

                <div className='row justify-content-center  '>

                    <div className='col-12 col-md-5 text-center'>
                        <span
                            className='text-format'
                            style={{ 'color': 'black', 'fontSize': '100%' }}
                        >کدی دریافت نکردید؟</span>

                        {stopTimer ?
                            (<span
                                onClick={resendOtp}
                                className='text-format'
                                style={{ 'color': '#0BA9B5', 'marginRight': '2%', 'fontSize': '100%' }}
                            >
                                <span style={{ 'marginRight': '1%' }}> ارسال مجدد</span>
                            </span>)
                            :
                            (<span
                                className='text-format'
                                style={{ 'color': '#0BA9B5', 'marginRight': '2%', 'fontSize': '100%' }}
                            >
                                <span>{formatTime(timer)}</span>
                                <span style={{ 'marginRight': '1%' }}>تا ارسال مجدد</span>
                            </span>)
                        }
                    </div>
                </div>
            </div>

            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

            <Modal
                open={openModal}
            >
                <Rules setOpenModal={setOpenModal} />
            </Modal>

        </div>

    )
}